import { createComponent, ComponentProps } from '@/internals/utils';

export type SidenavGroupLabelProps = ComponentProps;

/**
 * The `Sidenav.GroupLabel` component for use with the `Sidenav` component.
 *
 * @see https://rsuitejs.com/components/sidenav
 */
const SidenavGroupLabel = createComponent<'div', SidenavGroupLabelProps>({
  name: 'SidenavGroupLabel'
});

export default SidenavGroupLabel;
